import { useTranslator } from '@jutro/locale';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import messages from './MLPolicyTypeUtil.messages';

function MLPolicyTypeUtil() {
    const translator = useTranslator();

    const getPolicyTypeName = ((code) => {
        if (MLProductCodeUtil.isPersonalAuto(code)) {
            return translator(messages.auto);
        } else if (MLProductCodeUtil.isPersonalUmbrella(code)) {
            return translator(messages.umbrella);
        } else if (MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(code)) {
            return translator(messages.landlordHome);
        } else if (MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(code)) {
            return translator(messages.landlordCondo);
        } else if (MLProductCodeUtil.isHomeOwnersPartialTypeHome(code)) {
            return translator(messages.home);
        } else if (MLProductCodeUtil.isHomeOwnersPartialTypeRental(code)) {
            return translator(messages.renters);
        } else if (MLProductCodeUtil.isHomeOwnersPartialTypeCondo(code)) {
            return translator(messages.condo);
        } else if (MLProductCodeUtil.isHomeOwners(code)) {
            return translator(messages.homeowners);
        }

        console.error(new Error(`Unknown product code: ${code}`));
    });

    return {
        getPolicyTypeName,
    };
}

export default MLPolicyTypeUtil;
